import axios from 'axios';
import callApi from 'apis';
import CONFIG_API from 'apis/EndpointConfig';

const login = (params) => callApi(
  `${CONFIG_API.MERCHANTVIEW_API_BE}mc/auth/login`,
  'post',
  params,
);

const logout = (params) => callApi(
  `${CONFIG_API.MERCHANTVIEW_API_BE}mc/auth/logout`,
  'get',
  params,
);

const callRefreshToken = (params) => axios.post(
  `${CONFIG_API.MERCHANTVIEW_API_BE}mc/auth/refreshToken`,
  params,
);

const apiAccChangePass = (params) => callApi(
  `${CONFIG_API.MERCHANTVIEW_API_BE}mc/auth/changePassword`,
  'post',
  params,
);

const forgotPassword = (params) => callApi(
  `${CONFIG_API.MERCHANTVIEW_API_BE}mc/auth/resetPassword`,
  'post',
  params,
);

export {
  login,
  logout,
  callRefreshToken,
  apiAccChangePass,
  forgotPassword,
};
